var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress, IconButton, InputAdornment } from '@mui/material';
import { Search } from '@mui/icons-material';
import React, { useState } from 'react';
import { SigefApi } from '../apis/Sigef-api';
import { HandleError } from '../modules/utils/HandleError';
import { CommonUtils } from '../util/CommonUtils';
import { CustomInputForm } from './Forms/CustomInputForm';
export var SIGEFTextField = function (_a) {
    var sigefIsOnline = _a.sigefIsOnline, parcelaImovel = _a.parcelaImovel, onChange = _a.onChange, fieldError = _a.fieldError, cpfRequerente = _a.cpfRequerente, required = _a.required, onResultChange = _a.onResultChange, onValidChange = _a.onValidChange, onLoadingChange = _a.onLoadingChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.pecasIsSigef, pecasIsSigef = _c === void 0 ? true : _c, cpfRepresentanteLegal = _a.cpfRepresentanteLegal, tipoRequerente = _a.tipoRequerente, cnpjRequerente = _a.cnpjRequerente, requerimento = _a.requerimento, _d = _a.isEdit, isEdit = _d === void 0 ? false : _d;
    var _e = useState(false), loadingSearch = _e[0], setLoadingSearch = _e[1];
    var _f = useState(), sigefError = _f[0], setSigefError = _f[1];
    var _g = useState(), error = _g[0], setError = _g[1];
    var handleChange = function (event) {
        var _a;
        onChange(__assign(__assign({}, parcelaImovel), { codigoSIGEF: (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value }));
        setSigefError(undefined);
    };
    var onBlurCodigoSigef = function () { return __awaiter(void 0, void 0, Promise, function () {
        var codigoSIGEF, _tipo, _cpf, _cnpj, cpf, cnpj, currentTipoRequerente, hasCodigoSIGEF, hasCpf, hasCnpj, tipoDocumento, msg, response, err_1, message;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (loadingSearch || isEdit)
                        return [2 /*return*/];
                    codigoSIGEF = ((_a = parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.codigoSIGEF) === null || _a === void 0 ? void 0 : _a.trim()) || '';
                    _tipo = tipoRequerente || (requerimento ? CommonUtils.tipoRequerente(requerimento) : undefined);
                    _cpf = (cpfRepresentanteLegal || cpfRequerente || (requerimento ? CommonUtils.cpfRequerente(requerimento) : '')).toString().replace(/\D/g, '').trim();
                    _cnpj = (cnpjRequerente || (requerimento ? CommonUtils.cnpjRequerente(requerimento) : '')).toString().replace(/\D/g, '').trim();
                    cpf = _cpf;
                    cnpj = _cnpj;
                    currentTipoRequerente = _tipo;
                    hasCodigoSIGEF = !!codigoSIGEF;
                    hasCpf = !!cpf;
                    hasCnpj = !!cnpj;
                    if (!hasCodigoSIGEF) {
                        return [2 /*return*/];
                    }
                    if (!hasCpf && !hasCnpj) {
                        tipoDocumento = currentTipoRequerente === 'PJ' ? 'CNPJ da Empresa ou CPF do Representante' : 'CPF do Requerente';
                        setSigefError("".concat(tipoDocumento, " n\u00E3o identificado. Verifique os dados b\u00E1sicos."));
                        return [2 /*return*/];
                    }
                    if (!sigefIsOnline) {
                        msg = 'API SIGEF está OFFLINE no momento. Não é possível realizar a consulta.';
                        setSigefError(msg);
                        setError(new Error(msg));
                        return [2 /*return*/];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 6, 7, 8]);
                    setLoadingSearch(true);
                    onLoadingChange === null || onLoadingChange === void 0 ? void 0 : onLoadingChange(true);
                    setSigefError(undefined);
                    response = void 0;
                    if (!(currentTipoRequerente === 'PJ')) return [3 /*break*/, 3];
                    return [4 /*yield*/, performPJSearch(codigoSIGEF, cpf, cnpj)];
                case 2:
                    response = _d.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, handleSearch({ codigoSIGEF: codigoSIGEF, cpf: cpf, cnpj: cnpj })];
                case 4:
                    // Para PF, passamos ambos CPF e CNPJ se disponíveis, conforme solicitado
                    response = _d.sent();
                    handleTreatResponse(response);
                    _d.label = 5;
                case 5:
                    onValidChange === null || onValidChange === void 0 ? void 0 : onValidChange(true);
                    return [3 /*break*/, 8];
                case 6:
                    err_1 = _d.sent();
                    message = ((_c = (_b = err_1 === null || err_1 === void 0 ? void 0 : err_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || (err_1 === null || err_1 === void 0 ? void 0 : err_1.message) || 'Erro desconhecido favor contactar administrador.';
                    setSigefError(message);
                    setError(err_1);
                    onValidChange === null || onValidChange === void 0 ? void 0 : onValidChange(false);
                    return [3 /*break*/, 8];
                case 7:
                    setLoadingSearch(false);
                    onLoadingChange === null || onLoadingChange === void 0 ? void 0 : onLoadingChange(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var performPJSearch = function (codigoSIGEF, cpf, cnpj) { return __awaiter(void 0, void 0, Promise, function () {
        var response, pjErr_1, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 4]);
                    return [4 /*yield*/, handleSearch({ codigoSIGEF: codigoSIGEF, cpf: cpf, cnpj: cnpj })];
                case 1:
                    response = _a.sent();
                    if (!response || !response.content || response.content.length === 0) {
                        throw new Error('Content is empty with combined search');
                    }
                    handleTreatResponse(response);
                    return [2 /*return*/, response];
                case 2:
                    pjErr_1 = _a.sent();
                    console.debug('Search by combined params failed or returned empty, retrying with CNPJ only.', pjErr_1);
                    return [4 /*yield*/, handleSearch({ codigoSIGEF: codigoSIGEF, cnpj: cnpj })];
                case 3:
                    response = _a.sent();
                    handleTreatResponse(response);
                    return [2 /*return*/, response];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSearch = function (_a) {
        var codigoSIGEF = _a.codigoSIGEF, cpf = _a.cpf, cnpj = _a.cnpj;
        var params = {};
        if (codigoSIGEF)
            params.parcelaCodigo = codigoSIGEF;
        if (cpf)
            params.cpfRequerente = cpf;
        if (cnpj)
            params.titularCnpj = cnpj;
        return SigefApi.selectResumeByParams(params);
    };
    var handleTreatResponse = function (response) {
        var _a;
        var _b, _c, _d;
        if (!response) {
            throw new Error('Resposta do servidor inválida ou vazia.');
        }
        var content = [];
        if (Array.isArray(response)) {
            content = response;
        }
        else if (response.content) {
            content = response.content;
        }
        else if ((_b = response._embedded) === null || _b === void 0 ? void 0 : _b.parcelaViewList) {
            content = response._embedded.parcelaViewList;
        }
        if (!content || content.length === 0) {
            throw new Error('Código SIGEF ou CPF/CNPJ não encontrado.');
        }
        var rawParcela = content === null || content === void 0 ? void 0 : content[0];
        var area = 0;
        if (rawParcela.area !== undefined) {
            area = typeof rawParcela.area === 'string' ? Number(rawParcela.area.replace(',', '.')) : Number(rawParcela.area);
        }
        else if (rawParcela.areaHectares) {
            area = typeof rawParcela.areaHectares === 'string' ? Number(rawParcela.areaHectares.replace(',', '.')) : Number(rawParcela.areaHectares);
        }
        var mappedParcela = __assign(__assign(__assign(__assign({}, parcelaImovel), (_a = { codigoSIGEF: rawParcela.codigoSIGEF || rawParcela.parcelaCodigo || parcelaImovel.codigoSIGEF, denominacao: rawParcela.denominacao || rawParcela.nomeArea || '', area: area, codigoArt: rawParcela.codigoArt || rawParcela.art || '', municipio: (typeof rawParcela.municipio === 'object' && ((_c = rawParcela.municipio) === null || _c === void 0 ? void 0 : _c.nome)) ? rawParcela.municipio : (rawParcela.municipio && typeof rawParcela.municipio === 'string' ? { nome: rawParcela.municipio.split('-')[0].trim() } : null), matricula: rawParcela.matricula || parcelaImovel.matricula }, _a['geometria'] = rawParcela.geometria || '', _a['registroProfissionalSigef'] = rawParcela.registroProfissionalSigef || rawParcela.rt || '', _a['rtVeioDoSigef'] = !!rawParcela.responsavelTecnico, _a)), (rawParcela.responsavelTecnico ? { responsavelTecnico: rawParcela.responsavelTecnico } : {})), { unlock: (_d = parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.unlock) !== null && _d !== void 0 ? _d : false });
        onResultChange === null || onResultChange === void 0 ? void 0 : onResultChange(mappedParcela);
    };
    return (_jsxs(_Fragment, { children: [_jsx(CustomInputForm, { helperText: (pecasIsSigef && (sigefError || (fieldError === null || fieldError === void 0 ? void 0 : fieldError.codigoSIGEFError))) || '', error: pecasIsSigef && (!!sigefError || !!(fieldError === null || fieldError === void 0 ? void 0 : fieldError.codigoSIGEFError)), value: (parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.codigoSIGEF) || '', disabled: disabled || loadingSearch, label: "C\u00F3digo SIGEF da Parcela", InputProps: {
                    endAdornment: (_jsx(InputAdornment, __assign({ position: "end" }, { children: loadingSearch ? (_jsx(CircularProgress, { size: 20 })) : (_jsx(IconButton, __assign({ onClick: onBlurCodigoSigef, edge: "end" }, { children: _jsx(Search, {}) }))) })))
                }, onBlur: onBlurCodigoSigef, onChange: handleChange, required: required, name: "codigoSIGEF", variant: "outlined", id: "codigoSIGEF", "data-testid": "custom-input-sigef", inputProps: {
                    'data-testid': 'input-sigef'
                }, fullWidth: true }), _jsx(HandleError, { handleClose: function () {
                    setError(undefined);
                    setSigefError(undefined);
                }, error: error })] }));
};
